/* D Byk numbered menu drawer — accordion behaviour.
 *
 * The theme's HeaderDrawer (global.js) attaches a "close submenu" handler to every
 * <button> inside the drawer. Our accordion buttons would trigger it, so we handle
 * their clicks in the capture phase on the drawer root and stop the event there,
 * before it reaches those handlers. Everything else (opening/closing the drawer,
 * scroll lock, focus trap, Esc) is still done by the theme.
 */
(function () {
  'use strict';

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var btn = item.querySelector(':scope > .dbm-toggle');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function keepInView(root, btn) {
    var scroller = root.querySelector('.dbm-scroll');
    if (!scroller) return;
    var r = btn.getBoundingClientRect();
    var s = scroller.getBoundingClientRect();
    if (r.top < s.top || r.top > s.bottom - 120) {
      scroller.scrollBy({ top: r.top - s.top - 8, behavior: 'smooth' });
    }
  }

  function init(root) {
    if (!root || root.dataset.dbmReady) return;
    root.dataset.dbmReady = '1';

    root.addEventListener(
      'click',
      function (event) {
        var target = event.target.closest('.dbm-toggle, .dbm-close, .dbm-subtoggle');
        if (!target || !root.contains(target)) return;

        event.stopPropagation();
        event.preventDefault();

        if (target.classList.contains('dbm-subtoggle')) {
          // Group inside a section (e.g. Components > Drivetrain): one open at a time per section
          var sub = target.closest('.dbm-sub-item');
          if (!sub) return;
          var subOpen = !sub.classList.contains('is-open');
          var list = sub.parentElement;
          list.querySelectorAll(':scope > .dbm-sub-item.is-open').forEach(function (other) {
            if (other !== sub) {
              other.classList.remove('is-open');
              var b = other.querySelector(':scope > .dbm-subtoggle');
              if (b) b.setAttribute('aria-expanded', 'false');
            }
          });
          sub.classList.toggle('is-open', subOpen);
          target.setAttribute('aria-expanded', subOpen ? 'true' : 'false');
          if (subOpen) {
            setTimeout(function () {
              keepInView(root, target);
            }, 380);
          }
          return;
        }

        if (target.classList.contains('dbm-close')) {
          var details = target.closest('details');
          var summary = details && details.querySelector(':scope > summary');
          if (summary) summary.click();
          return;
        }

        var item = target.closest('.dbm-item');
        if (!item) return;
        var willOpen = !item.classList.contains('is-open');

        root.querySelectorAll('.dbm-item.is-open').forEach(function (other) {
          if (other !== item) setOpen(other, false);
        });
        setOpen(item, willOpen);

        if (willOpen) {
          setTimeout(function () {
            keepInView(root, target);
          }, 420);
        }
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('[data-dbm]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
